export default __webpack_public_path__ + "static/media/no-result.c6416782.png";